import React, { useEffect, useState } from "react";
import { MeetingService } from "../../services/MeetingService";
import { toast } from "react-toastify";

const Participants = ({ meetingId }) => {
  const [participants, setParticipants] = useState([]);

  useEffect(() => {
    const fetchParticipants = async () => {
      try {
        const res = await MeetingService.getParticipants(meetingId);
        setParticipants(res.data);
      } catch (error) {
        toast.error(error?.message || "Failed to fetch participants");
      }
    };

    fetchParticipants();
  }, [meetingId]); 

  const handleRemoveParticipant = async (meetingId, participantId) => {
    try {
      await MeetingService.removeParticipant(meetingId, participantId);
      setParticipants((prev) =>
        prev.filter(
          (p) =>
            !(p.meetingId === meetingId && p.participantId === participantId)
        )
      );
      toast.success("Participant Removed Successfully");
    } catch (error) {
      toast.error(error.message || "Failed to remove participant");
    }
  };

  return (
    <div className="mb-6">
      <h3 className="text-sm font-semibold text-gray-700 mb-2">Participants</h3>
      {participants.length > 0 ? (
        <ul className="flex flex-wrap gap-2">
          {participants.map((item) => (
            <li
              key={item.id}
              className="flex justify-between items-center bg-green-100 px-3 py-1 rounded-full text-sm border"
            >
              <span className="text-gray-800">{item.members?.name}</span>
              <button
                onClick={() =>
                  handleRemoveParticipant(item.meetingId, item.participantId)
                }
                className="ml-2 text-red-500 hover:text-red-700 text-lg font-bold leading-none"
              >
                ×
              </button>
            </li>
          ))}
        </ul>
      ) : (
        <p className="text-sm text-gray-500">No participants added yet.</p>
      )}
    </div>
  );
};

export default Participants;
